export default "__VITE_ASSET__DnC1KFNN__"